import React from 'react';
import { connect } from 'react-redux';

import mea from '../../../services/mea';

import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import HowItWorksComponent from '../../HowItWorksComponent';
import MeaCarouselComponent from './MeaCarouselComponent';
import MobileMeaOfferSelection from './MobileMeaOfferSelection';
import DesktopMeaOfferSelection from './DesktopMeaOfferSelection';

import './HomePage.scss';

export class HomePage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE);
        this.props.fetchMeasIfNeeded(mea.constants.ONLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.OFFLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.EBON_OFFER);
    }

    render() {
        const { i18nHome } = this.props;

        return (
            <main role="main" className="conteneur" id="p-accueil">
                <HeadComponent title={i18nHome.TITLE} description={i18nHome.DESCRIPTION} />

                <MeaCarouselComponent />

                <HowItWorksComponent showTitle showButtons />

                <DesktopMeaOfferSelection isOnline />
                <MobileMeaOfferSelection isOnline />

                <DesktopMeaOfferSelection isEbon />
                <MobileMeaOfferSelection isEbon />

                <DesktopMeaOfferSelection isOffline />
                <MobileMeaOfferSelection isOffline />
            </main>
        );
    }
}

const mapStateToProps = state => ({
    i18nHome: state.i18n.page.HOME
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HomePage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js